import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import {pagination} from "config/config";
import {Alert, Badge, Card, Spinner} from "reactstrap";
import Container from "reactstrap/lib/Container";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import ValidationForm from "../../../../validation/form";
import Col from "reactstrap/lib/Col";
import Row from "reactstrap/lib/Row";
import Button from "reactstrap/lib/Button";
import ReactToPrint from "react-to-print";
import TableActionButtons from "../../admin/TableActionButtons";

// react plugin used to create datetimepicker
import DropdownItem from "reactstrap/lib/DropdownItem";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import UncontrolledDropdown from "reactstrap/lib/UncontrolledDropdown";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import invoiceReconciliationService from "services/invoiceReconciliationService";
import fileDownloadService from "services/fileDownloadService";
import auth from "services/authService";
// import CompleteBooking from "./bookshipment/CompleteBooking";
// import Timeline from "./timeline/Timeline";
// import BookShipment from "./BookShipment";
import {toast} from "react-toastify";
import {COURIER} from "constants/constants";

const dateFormat = "YYYY-MM-DD";

class ShippingHistory extends ValidationForm {
  state = {
    data: {
      uploadClearanceDocumentFilename: null,
    },
    errors: {},
    formSubmitted: true,
    isLoading: false,
    history: [],
    historyDetailModal: false,
    currentHistory: null,
    moveToCompleteBooking: false,
    completeBookingShipmentId: 0,
    trackingModal: false,
    fetchingTrackingInfo: false,
    trackingDetail: null,
    voidShipmentModal: false,
    voidShipmentInProgress: false,
    voidShipmentDetail: null,
    showInvoiceUploadFields: false,
    uploadClearanceDocumentInProgress: false,
    uploadClearanceDocumentShipmentDetail: null,
    uploadClearanceDocumentFormData: null,
    uploadClearanceDocumentFilename: null,
    fileProperties: {
      maxAllowedFileSize: 1048576,
      mimeTypes: ["text/csv"],
    },
    responseAcceptedReconciledShipmentList: null,
    responseTaxAndVatRecords: null,
    responseDuplicateWaybillNumbers: null,
    responseNotFoundShipmentList: null,
    responseReconciliationErrors: null,
    responseCounts: {
      discrepancyCount: 0,
      passedCount: 0,
      duplicateCount: 0,
      notFoundCount: 0,
      fileErrorCount: 0,
      taxAndVatRecordsCount: 0,
    },
  };

  schema = {};

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  async componentDidMount() {
    // try {
    //   this.setState({ formSubmitted: true, searchTriggered: true });
    //   const history = await shipmentService.fetchShipmentHistoryRecentRecord();
    //   await this.updateShippingDocumentTypeList();
    //   this.setState({ formSubmitted: false, history });
    // } catch (ex) {
    //   this.setState({ formSubmitted: false });
    // }
  }

  render() {
    // if (this.state.editShipment) {
    //   return (
    //     <BookShipment editShipmentId={this.state.editShipmentId}></BookShipment>
    //   );
    // }

    return (
        <>
            <SimpleHeader name="Invoice Reconciliation" parentName="Tables"/>
            <Container className="mt--6" fluid>
                {this.showInvoiceUploadFields()}
                {this.displayReconciliationCounts()}
                {this.loadTableForAcceptedReconciledShipmentList()}
                {this.loadTableForVatAndDutyList()}
                {this.loadTableForNotFoundShipmentList()}
                {this.loadTableForDuplicateShipmentList()}
                {this.showErrorMessage()}
                <br/>
                {this.showSaveButton()}
            </Container>
        </>
    );
  }

    handleSubmit() {
    }

  loadHistoryTableTrackingNumbers(
      courier,
      waybillNumber,
      trackingNumbers,
      status,
  ) {
    if (this.hidePartnerTrackingNumber(status)) {
      return;
    }

    const trackingNumbersDisplay = trackingNumbers.map((tn, index) => {
      return (
          <>
              <br/>
              {(courier === COURIER.FEDEX ||
                  courier === COURIER.FEDEX_PRIORITY) && (
                  <a
                      href={`https://www.fedex.com/fedextrack/?trknbr=${tn}`}
                      target="_blank"
                      className="text-primary font-weight-bold text-underline"
                  >
                      {tn}
                  </a>
              )}
              {courier === COURIER.UPS && (
                  <a
                      href={`https://www.ups.com/WebTracking/processInputRequest?tracknum=${tn}&loc=en_NG&requester=ST/trackdetails`}
                      target="_blank"
                      className="text-primary font-weight-bold text-underline"
                  >
                      {tn}
                  </a>
              )}
              {courier === COURIER.DHL && (
                  <a
                      href={`https://mydhl.express.dhl/us/en/tracking.html#/results?id=${tn}`}
                      target="_blank"
                      className="text-primary font-weight-bold text-underline"
                  >
                      {waybillNumber} / {tn}
                  </a>
              )}
              {(courier === COURIER.ARAMEX ||
                  courier === COURIER.ARAMEX_PREMIUM) && (
                  <a
                      href={`https://www.aramex.com/sa/en/track/track-results-new?ShipmentNumber=${tn}`}
                      target="_blank"
                      className="text-primary font-weight-bold text-underline"
                  >
                      {tn}
                  </a>
              )}
          </>
      );
    });
    return <>{trackingNumbersDisplay}</>;
  }

  loadTableForAcceptedReconciledShipmentList() {
    if (
        !this.state.responseAcceptedReconciledShipmentList ||
        this.state.responseAcceptedReconciledShipmentList.length === 0
    ) {
      return null;
    }

    return (
        <Card>
            <ToolkitProvider
                data={this.state.responseAcceptedReconciledShipmentList}
                keyField="waybillNumber"
                columns={[
                    {
                        dataField: "remarks",
                        text: "Remarks",
                        sort: true,
                    },
                    {
                        dataField: "waybillNumber",
                        text: "Waybill No.",
                        sort: true,
                    },
                    {
                        dataField: "invoiceNumber",
                        text: "Invoice No.",
                        sort: true,
                    },
                    {
                        dataField: "trackingNumber",
                        text: "Tracking No.",
                        sort: true,
                    },
                    {
                        dataField: "createdAt",
                        text: "Date",
                        sort: true,
                    },
                    {
                        dataField: "origin",
                        text: "Sender",
                        sort: true,
                        formatter: (cell, row) => {
                            if (row.origin) {
                                return (
                                    <>
                                        {row.origin.fullname} <br/>
                                        <b className="text-primary">{row.origin.state}</b>
                                    </>
                                );
                            } else {
                                return "";
                            }
                        },
                        filterValue: (cell, row) => {
                            return row.origin.fullname + " " + row.origin.state;
                        },
                        csvExport: false,
                    },
                    {
                        dataField: "destination",
                        text: "Recipient",
                        sort: true,
                        formatter: (cell, row) => {
                            return (
                                <>
                                    {row.destination.fullname} <br/>
                                    <b className="text-primary">{row.destination.state}</b>
                                </>
                            );
                        },
                        filterValue: (cell, row) => {
                            return row.destination.fullname + " " + row.destination.state;
                        },
                        csvExport: false,
                    },
                    {
                        dataField: "status",
                        text: "Status",
                        sort: true,
                        filterValue: (cell, row) => {
                            const status = row.status.toUpperCase();
                            if (
                                this.isAdminRole() &&
                                row.inTransit &&
                                (status === "BOOKED" || status === "COURIER_ASSIGNED")
                            ) {
                                return "ON THE WAY";
                            } else return status;
                        },
                        formatter: (cell, row) => {
                            return <>{this.displayStatus(row.status, row.inTransit)}</>;
                        },
                    },
                    {
                        dataField: "origin",
                        text: "Sender Fullname",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.origin.fullname}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${row.origin.fullname}`;
                        },
                    },
                    {
                        dataField: "origin",
                        text: "Sender PhoneNumber",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.origin.phoneNumber}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${row.origin.phoneNumber}`;
                        },
                    },
                    {
                        dataField: "origin",
                        text: "Sender Address",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.origin.address}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${row.origin.address}`;
                        },
                    },
                    {
                        dataField: "origin",
                        text: "Sender State",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.origin.state}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${row.origin.state}`;
                        },
                    },
                    {
                        dataField: "destination",
                        text: "Receiver Fullname",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.destination.fullname}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${row.destination.fullname}`;
                        },
                    },
                    {
                        dataField: "destination",
                        text: "Receiver PhoneNumber",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.destination.phoneNumber}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${" " + row.destination.phoneNumber}`;
                        },
                    },
                    {
                        dataField: "destination",
                        text: "Receiver Address",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.destination.address}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${row.destination.address}`;
                        },
                    },
                    {
                        dataField: "destination",
                        text: "Receiver State",
                        sort: true,
                        hidden: true,
                        formatter: (cell, row) => {
                            return <>{row.destination.state}</>;
                        },
                        csvFormatter: (cell, row) => {
                            return `${row.destination.state}`;
                        },
                    },
                    {
                        dataField: "packageValue",
                        text: "Package Value",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "invoicedWeight",
                        text: "Invoiced Weight",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "grossWeight",
                        text: "grossWeight",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "billableWeight",
                        text: "billableWeight",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "invoicedAmount",
                        text: "Invoiced Amount",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "paymentAmount",
                        text: "Payment Amount PLUS Duty",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "paymentAmount",
                        text: "Payment Amount LESS Duty",
                        sort: true,
                        hidden: true,
                        csvFormatter: (cell, row) => {
                            return `${row.paymentAmount - row.customsDutyFee}`;
                        },
                    },
                    {
                        dataField: "shippingRate",
                        text: "shippingRate",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "shippingBoxFee",
                        text: "shippingBoxFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "additionalDocumentsFee",
                        text: "additionalDocumentsFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "signatureServiceFee",
                        text: "signatureServiceFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "insuranceFee",
                        text: "insuranceFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "bubbleWrapFee",
                        text: "bubbleWrapFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "extraPackagingFee",
                        text: "extraPackagingFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "fuelSurchargeFee",
                        text: "fuelSurchargeFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "pickUpFee",
                        text: "pickUpFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "vacuumSealingFee",
                        text: "vacuumSealingFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "ziplocBagFee",
                        text: "ziplocBagFee",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "customsDutyFee",
                        text: "customsDutyFee",
                        sort: true,
                        hidden: true,
                    },

                    {
                        dataField: "fdaFees",
                        text: "fdaFees",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "tscaFees",
                        text: "tscaFees",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "foodDocumentationFees",
                        text: "foodDocumentationFees",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "seaFoodDocumentationFees",
                        text: "seaFoodDocumentationFees",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "wigDocumentationFees",
                        text: "wigDocumentationFees",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "otherFees",
                        text: "otherFees",
                        sort: true,
                        hidden: true,
                    },
                    {
                        dataField: "discountAmount",
                        text: "discountAmount",
                        sort: true,
                        hidden: true,
                    },
                ]}
                search
            >
                {(props) => (
                    <div className="py-4 table-responsive">
                        <TableActionButtons {...props}>
                            <ReactToPrint
                                trigger={() => (
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="buttons-copy buttons-html5"
                                        id="print-tooltip"
                                    >
                                        Print
                                    </Button>
                                )}
                                content={() => this.componentRef}
                            />
                        </TableActionButtons>
                        <BootstrapTable
                            size="sm"
                            condensed
                            hover
                            ref={(el) => (this.componentRef = el)}
                            {...props.baseProps}
                            bootstrap4={true}
                            pagination={pagination}
                            bordered={false}
                            id="react-bs-table"
                        />
                    </div>
                )}
            </ToolkitProvider>
        </Card>
    );
  }

    loadTableForVatAndDutyList() {
        if (
            !this.state.responseTaxAndVatRecords ||
            this.state.responseTaxAndVatRecords.length === 0
        ) {
            return null;
        }

        return (
            <Card>
                <ToolkitProvider
                    data={this.state.responseTaxAndVatRecords}
                    keyField="waybillNumber"
                    columns={[
                        {
                            dataField: "createdAt",
                            text: "Ship Date",
                            sort: true,
                        },
                        {
                            dataField: "invoiceType",
                            text: "Invoice Type",
                            sort: true,
                        },
                        {
                            dataField: "waybillNumber",
                            text: "Waybill No.",
                            sort: true,
                        },
                        {
                            dataField: "trackingNumber",
                            text: "Tracking No.",
                            sort: true,
                        },
                        {
                            dataField: "grossWeight",
                            text: "grossWeight",
                            sort: true,
                            hidden: true,
                        },
                        {
                            dataField: "invoicedAmount",
                            text: "Invoiced Customs Amount",
                            sort: true,
                        },
                        {
                            dataField: "customsDutyFee",
                            text: "Billed Customs Fee",
                            sort: true,
                        },
                        {
                            dataField: "packageValue",
                            text: "Package Value",
                            sort: true,
                        },
                        {
                            dataField: "invoicedWeight",
                            text: "Invoiced Weight",
                            sort: true,
                            hidden: true,
                        },
                        {
                            dataField: "destination",
                            text: "Destination Country",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.destination.state.split("_")[0]}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.destination.state.split("_")[0]}`;
                            },
                        },
                        {
                            dataField: "invoiceNumber",
                            text: "Invoice No.",
                            sort: true,
                        },
                        {
                            dataField: "origin",
                            text: "Sender",
                            sort: true,
                            formatter: (cell, row) => {
                                if (row.origin) {
                                    return (
                                        <>
                                            {row.origin.fullname} <br/>
                                            <b className="text-primary">{row.origin.state}</b>
                                        </>
                                    );
                                } else {
                                    return "";
                                }
                            },
                            filterValue: (cell, row) => {
                                return row.origin.fullname + " " + row.origin.state;
                            },
                            csvExport: false,
                        },
                        {
                            dataField: "destination",
                            text: "Recipient",
                            sort: true,
                            formatter: (cell, row) => {
                                return (
                                    <>
                                        {row.destination.fullname} <br/>
                                        <b className="text-primary">{row.destination.state}</b>
                                    </>
                                );
                            },
                            filterValue: (cell, row) => {
                                return row.destination.fullname + " " + row.destination.state;
                            },
                            csvExport: false,
                        },
                        {
                            dataField: "origin",
                            text: "Sender Fullname",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.origin.fullname}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.origin.fullname}`;
                            },
                        },
                        {
                            dataField: "origin",
                            text: "Sender PhoneNumber",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.origin.phoneNumber}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.origin.phoneNumber}`;
                            },
                        },
                        {
                            dataField: "origin",
                            text: "Sender Address",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.origin.address}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.origin.address}`;
                            },
                        },
                        {
                            dataField: "origin",
                            text: "Sender State",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.origin.state}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.origin.state}`;
                            },
                        },
                        {
                            dataField: "destination",
                            text: "Receiver Fullname",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.destination.fullname}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.destination.fullname}`;
                            },
                        },
                        {
                            dataField: "destination",
                            text: "Receiver PhoneNumber",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.destination.phoneNumber}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${" " + row.destination.phoneNumber}`;
                            },
                        },
                        {
                            dataField: "destination",
                            text: "Receiver Address",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.destination.address}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.destination.address}`;
                            },
                        },
                        {
                            dataField: "destination",
                            text: "Receiver State",
                            sort: true,
                            hidden: true,
                            formatter: (cell, row) => {
                                return <>{row.destination.state}</>;
                            },
                            csvFormatter: (cell, row) => {
                                return `${row.destination.state}`;
                            },
                        },
                    ]}
                    search
                >
                    {(props) => (
                        <div className="py-4 table-responsive">
                            <TableActionButtons {...props}>
                                <ReactToPrint
                                    trigger={() => (
                                        <Button
                                            color="primary"
                                            size="sm"
                                            className="buttons-copy buttons-html5"
                                            id="print-tooltip"
                                        >
                                            Print
                                        </Button>
                                    )}
                                    content={() => this.componentRef}
                                />
                            </TableActionButtons>
                            <BootstrapTable
                                size="sm"
                                condensed
                                hover
                                ref={(el) => (this.componentRef = el)}
                                {...props.baseProps}
                                bootstrap4={true}
                                pagination={pagination}
                                bordered={false}
                                id="react-bs-table"
                            />
                        </div>
                    )}
                </ToolkitProvider>
            </Card>
        );
    }

  loadTableForDuplicateShipmentList() {
    if (
        !this.state.responseDuplicateWaybillNumbers ||
        this.state.responseDuplicateWaybillNumbers.length === 0
    ) {
      return null;
    }

    return (
        <Card>
            <ToolkitProvider
                data={this.state.responseDuplicateWaybillNumbers}
                keyField="waybillNumber"
                columns={[
                    {
                        dataField: "remarks",
                        text: "Remarks",
                        sort: true,
                        formatter: (cell, row) => {
                            return `Duplicate Waybill No.`;
                        },
                        csvFormatter: (cell, row) => {
                            return `Duplicate Waybill No.`;
                        },
                    },
                    {
                        dataField: "waybillNumber",
                        text: "Waybill No.",
                        sort: true,
                    },
                    {
                        dataField: "invoiceNumber",
                        text: "Invoice No.",
                        sort: true,
                    },
                    {
                        dataField: "invoicedWeight",
                        text: "Invoiced Weight",
                        sort: true,
                    },
                    {
                        dataField: "amount",
                        text: "Invoiced Amount",
                        sort: true,
                    },
                    {
                        dataField: "senderName",
                        text: "Sender Name",
                        sort: true,
                    },
                    {
                        dataField: "senderAddress",
                        text: "Sender Address",
                        sort: true,
                    },
                    {
                        dataField: "receiverName",
                        text: "Receiver Name",
                        sort: true,
                    },
                    {
                        dataField: "receiverAddress",
                        text: "Receiver Address",
                        sort: true,
                    },
                ]}
                search
            >
                {(props) => (
                    <div className="py-4 table-responsive">
                        <TableActionButtons {...props}>
                            <ReactToPrint
                                trigger={() => (
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="buttons-copy buttons-html5"
                                        id="print-tooltip"
                                    >
                                        Print
                                    </Button>
                                )}
                                content={() => this.componentRef}
                            />
                        </TableActionButtons>
                        <BootstrapTable
                            size="sm"
                            condensed
                            hover
                            ref={(el) => (this.componentRef = el)}
                            {...props.baseProps}
                            bootstrap4={true}
                            pagination={pagination}
                            bordered={false}
                            id="react-bs-table"
                        />
                    </div>
                )}
            </ToolkitProvider>
        </Card>
    );
  }

  loadTableForNotFoundShipmentList() {
    if (
        !this.state.responseNotFoundShipmentList ||
        this.state.responseNotFoundShipmentList.length === 0
    ) {
      return null;
    }

    return (
        <Card>
            <ToolkitProvider
                data={this.state.responseNotFoundShipmentList}
                keyField="waybillNumber"
                columns={[
                    {
                        dataField: "remarks",
                        text: "Remarks",
                        sort: true,
                    },
                    {
                        dataField: "waybillNumber",
                        text: "Waybill No.",
                        sort: true,
                    },
                    {
                        dataField: "invoiceNumber",
                        text: "Invoice No.",
                        sort: true,
                    },
                    {
                        dataField: "invoicedWeight",
                        text: "Invoiced Weight",
                        sort: true,
                    },
                    {
                        dataField: "amount",
                        text: "Invoiced Amount",
                        sort: true,
                    },
                    {
                        dataField: "senderName",
                        text: "Sender Name",
                        sort: true,
                    },
                    {
                        dataField: "senderAddress",
                        text: "Sender Address",
                        sort: true,
                    },
                    {
                        dataField: "receiverName",
                        text: "Receiver Name",
                        sort: true,
                    },
                    {
                        dataField: "receiverAddress",
                        text: "Receiver Address",
                        sort: true,
                    },
                ]}
                search
            >
                {(props) => (
                    <div className="py-4 table-responsive">
                        <TableActionButtons {...props}>
                            <ReactToPrint
                                trigger={() => (
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="buttons-copy buttons-html5"
                                        id="print-tooltip"
                                    >
                                        Print
                                    </Button>
                                )}
                                content={() => this.componentRef}
                            />
                        </TableActionButtons>
                        <BootstrapTable
                            size="sm"
                            condensed
                            hover
                            ref={(el) => (this.componentRef = el)}
                            {...props.baseProps}
                            bootstrap4={true}
                            pagination={pagination}
                            bordered={false}
                            id="react-bs-table"
                        />
                    </div>
                )}
            </ToolkitProvider>
        </Card>
    );
  }

  displayReconciliationCounts = () => {
    if (!this.state.responseAcceptedReconciledShipmentList) {
      return null;
    }

    return (
        <div className="text-center mb--1">
            <hr className="m-2"/>
            <h2>
                {this.state.responseCounts.passedCount > 0 && (
                    <Badge color="success">
                        PASSED: {this.state.responseCounts.passedCount}
                    </Badge>
                )}{" "}
                {this.state.responseCounts.taxAndVatRecordsCount > 0 && (
                    <Badge color="success">
                        TAX & VAT: {this.state.responseCounts.taxAndVatRecordsCount}
                    </Badge>
                )}{" "}
                {this.state.responseCounts.discrepancyCount > 0 && (
                    <Badge color="warning">
                        DISCREPANCY: {this.state.responseCounts.discrepancyCount}
                    </Badge>
                )}{" "}
                {this.state.responseCounts.duplicateCount > 0 && (
                    <Badge color="info text-indigo">
                        DUPLICATE: {this.state.responseCounts.duplicateCount}
                    </Badge>
                )}{" "}
                {this.state.responseCounts.notFoundCount > 0 && (
                    <Badge color="default">
                        NOT FOUND: {this.state.responseCounts.notFoundCount}
                    </Badge>
                )}{" "}
                {this.state.responseCounts.fileErrorCount > 0 && (
                    <Badge color="danger">
                        UPLOAD ERROR: {this.state.responseCounts.fileErrorCount}
                    </Badge>
                )}{" "}
            </h2>
        </div>
    );
  };

  displayStatus(status, inTransit) {
    status = status.toUpperCase();
    let statusColor = "";
    let classes = "";

    if (
        this.isAdminRole() &&
        inTransit &&
        (status === "BOOKED" || status === "COURIER_ASSIGNED")
    ) {
      statusColor = "info";
      classes = "text-indigo";
      status = "ON THE WAY";
    } else if (status === "BOOKED" || status === "COURIER_ASSIGNED") {
      statusColor = "default";
    } else if (status === "CANCELED" || status === "VOIDED") {
      statusColor = "danger";
    } else if (status === "PENDING") {
      statusColor = "secondary";
    } else if (status === "DELIVERED") {
      statusColor = "success";
    } else if (status === "PENDING_ISSUE") {
      statusColor = "warning";
    } else if (status === "AWAITING_PAYMENT_CONFIRMATION") {
      return "";
    }

    return (
        <h3>
            <Badge color={statusColor} className={classes}>
                {status}
            </Badge>
        </h3>
    );
  }

  doPartnerConfirmation(shipment) {
    if (this.isAdminRole() && !!shipment.hasBillingGroup) {
      return (
          <>
              <i class="fas fa-user-plus text-lg text-success"></i>{" "}
          </>
      );
    }
  }

  loadTableContextMenu(toggleModal, row) {
    let status = row.status.toUpperCase();
    return (
        <UncontrolledDropdown>
            <DropdownToggle
                className="btn-icon-only text-primary h-25 mx-0"
                color=""
                role="button"
                size="sm"
            >
                <i className="fas fa-ellipsis-v"/>
            </DropdownToggle>
            <DropdownMenu
                className="dropdown-menu-arrow pt-0 overflow-hidden "
                right
            >
                <div className="px-3 py-2 mb-1 bg-gradient-primary">
                    <h6 className="text-sm text-white m-0">{row.trackingNumber}</h6>
                </div>
                <DropdownItem divider></DropdownItem>

                {this.isAdminRole() &&
                    (status === "BOOKED" ||
                        status === "COURIER_ASSIGNED" ||
                        status === "DELIVERED") && (
                        <>
                            <DropdownItem
                                onClick={async () => {
                                    try {
                                        let data =
                                            await fileDownloadService.getWaybillDownloadToken(
                                                row.trackingNumber,
                                            );
                                        this.downloadFile(data.message);
                                    } catch (ex) {
                                        if (ex.response) {
                                            toast.error(ex.response.data.message);
                                        }
                                    }
                                }}
                                className="text-default"
                            >
                                <i className="fas fa-download text-primary"/>
                                Download Waybill
                            </DropdownItem>
                            <DropdownItem
                                onClick={async () => {
                                    try {
                                        let data =
                                            await fileDownloadService.getInvoiceDownloadToken(
                                                row.trackingNumber,
                                            );
                                        this.downloadFile(data.message);
                                    } catch (ex) {
                                        if (ex.response) {
                                            toast.error(ex.response.data.message);
                                        }
                                    }
                                }}
                                className="text-default"
                            >
                                <i className="far fa-file-alt text-primary"/>
                                Download INVOICE
                            </DropdownItem>
                            <DropdownItem divider></DropdownItem>
                        </>
                    )}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
  }

  downloadFile(token) {
    const downloadUrl = fileDownloadService.getFileDownloadUrl(token);
    const link = document.createElement("a");
    document.body.appendChild(link);
    link.href = downloadUrl;
    link.setAttribute("type", "hidden");
    link.click();
  }

  showInvoiceUploadFields = () => {
    return (
        <>
            <div className="text-danger text-center font-weight-bold">
                ONLY CSV FILE SUPPORTED
                <br/>
                <br/>
            </div>
            <div className="text-primary text-center font-weight-bold">
                Mandatory Column Headers:
            </div>
            <div className="text-black text-center font-weight-bold">
                <b>invoice_number, waybill_number, billed_weight, payment_amount</b>
            </div>
            <br/>
            <Row>
                <Col className="col-6 text-center text-wrap text-break font-weight-bold">
                    {this.state.uploadClearanceDocumentFilename}
                </Col>
            </Row>
            <br/>
            <Row>
                <Col className="col-6 text-center">
                    <label className="btn btn-primary btn-md">
              <span className={this.state.processingImage ? "" : "d-none"}>
                <Spinner type="border" size="sm"></Spinner>
              </span>
                        &nbsp; Select Partner Invoice Document
                        <input
                            type="file"
                            name="file"
                            className="d-none"
                            onChange={(event) => {
                                this.uploadClearanceDocumentChangeHandler(event);
                            }}
                        />
                    </label>
                </Col>
                <Col className="col-6 text-center">
                    <Button
                        color="success"
                        type="button"
                        onClick={async () => {
                            await this.submitClearanceDocument();
                        }}
                        disabled={
                            this.state.uploadClearanceDocumentInProgress ||
                            !this.state.uploadClearanceDocumentFormData
                        }
                    >
              <span
                  className={
                      this.state.uploadClearanceDocumentInProgress ? "" : "d-none"
                  }
              >
                <Spinner type="border" size="sm"></Spinner> Submitting Clearance
                Document...
              </span>
                        <span
                            className={
                                this.state.uploadClearanceDocumentInProgress ? "d-none" : ""
                            }
                        >
                Submit Clearance Document
              </span>
                    </Button>
                </Col>
            </Row>
        </>
    );
  };

  showErrorMessage = () => {
    if (
        !this.state.responseReconciliationErrors ||
        this.state.responseReconciliationErrors.length === 0
    ) {
      return null;
    }
    return (
        <Alert color="danger" className="text-center">
            <div className="alert-body">
                {this.state.responseReconciliationErrors}
            </div>
        </Alert>
    );
  };

  showSaveButton = () => {
    if (
        !this.state.responseAcceptedReconciledShipmentList ||
        this.state.responseAcceptedReconciledShipmentList.length === 0
    ) {
      return null;
    }

    return (
        <div className="text-center">
            <Button
                color="success"
                type="button"
                size="lg"
                onClick={async () => {
                    await this.doFinalizeReconciledInvoices();
                }}
                disabled={
                    this.state.uploadClearanceDocumentInProgress ||
                    !this.state.uploadClearanceDocumentFormData
                }
            >
          <span
              className={
                  this.state.uploadClearanceDocumentInProgress ? "" : "d-none"
              }
          >
            <Spinner type="border" size="sm"></Spinner> Finalizing Reconciled
            Invoice(s)
          </span>
                <span
                    className={
                        this.state.uploadClearanceDocumentInProgress ? "d-none" : ""
                    }
                >
            Finalize Reconciled Invoice(s)
          </span>
            </Button>
        </div>
    );
  };

  async uploadClearanceDocumentChangeHandler(event) {
    this.setState({
      uploadClearanceDocumentFormData: null,
      uploadClearanceDocumentFilename: null,
    });

    if (!event.target.files[0]) return;

    if (
        !this.isValidSize(event, this.state.fileProperties.maxAllowedFileSize)
    ) {
      toast.error(
          "Allowed file size (" +
          this.state.fileProperties.maxAllowedFileSize +
          " bytes) exceeded",
      );
      return;
    }

    if (!this.isValidMimeType(event, this.state.fileProperties.mimeTypes)) {
      toast.error("Upload file type is unsupported.");
      return;
    }

    let file = event.target.files[0];

    try {
      const formData = new FormData();
      if (file.type.includes("csv")) {
        formData.append("file", file, file.name);
        this.setState({
          uploadClearanceDocumentFormData: formData,
          uploadClearanceDocumentFilename: file.name,
        });
      } else {
        toast.error("Selected file type is not supported.");
      }
    } catch (err) {
      console.log(err);
    }
  }

  getFinalizationData() {
    const data = [];
    this.state.responseAcceptedReconciledShipmentList.map((rec) => {
      data[data.length] = {
        waybillNumber: rec.waybillNumber,
        invoiceNumber: rec.invoiceNumber,
        invoicedAmount: rec.invoicedAmount,
      };
    });

      let response = {shipments: data};
    return response;
  }

  async doFinalizeReconciledInvoices() {
    try {
      this.setState({
        uploadClearanceDocumentInProgress: true,
      });

      let resp = await invoiceReconciliationService.finalizeReconciledInvoices(
          this.getFinalizationData(),
      );

      toast.success(resp.message);

      this.setState({
        uploadClearanceDocumentInProgress: false,
      });
    } catch (ex) {
      this.setState({
        uploadClearanceDocumentInProgress: false,
      });
    }
  }

  async submitClearanceDocument() {
    try {
      this.setState({
        processingImage: true,
        uploadClearanceDocumentInProgress: true,
        responseAcceptedReconciledShipmentList: null,
        responseTaxAndVatRecords: null,
        responseDuplicateWaybillNumbers: null,
        responseNotFoundShipmentList: null,
        responseReconciliationErrors: null,
        responseCounts: {
          discrepancyCount: 0,
          passedCount: 0,
          taxAndVatRecordsCount: 0,
          duplicateCount: 0,
          notFoundCount: 0,
          fileErrorCount: 0,
        },
      });

      let resp = await invoiceReconciliationService.uploadInvoiceDocument(
          this.state.uploadClearanceDocumentFormData,
      );

      let responseCounts = {
        discrepancyCount: resp.data.discrepancyCount,
        passedCount: resp.data.passedCount,
        taxAndVatRecordsCount: resp.data.taxAndVatRecordsCount,
        duplicateCount: resp.data.duplicateCount,
        notFoundCount: resp.data.notFoundCount,
        fileErrorCount: resp.data.fileErrorCount,
      };

      toast.success(resp.message);
      console.log(resp.data);
      this.setState({
        processingImage: false,
        uploadClearanceDocumentShipmentDetail: null,
        uploadClearanceDocumentInProgress: false,
        showInvoiceUploadFields: false,
        responseAcceptedReconciledShipmentList:
        resp.data.acceptedReconciledShipmentList,
        responseTaxAndVatRecords: resp.data.taxAndVatRecords,
        responseDuplicateWaybillNumbers: resp.data.duplicateWaybillNumbers,
        responseInvoiceDiscrepancyShipmentList:
        resp.data.invoiceDiscrepancyShipmentList,
        responseNotFoundShipmentList: resp.data.notFoundList,
        responseReconciliationErrors: resp.data.errors,
        responseCounts,
      });
    } catch (ex) {
      this.setState({
        processingImage: false,
        uploadClearanceDocumentInProgress: false,
      });
    }
  }

  isValidMimeType(event, acceptedTypes) {
    //getting file object
    let file = event.target.files[0];
    let isValid = false;
    // compare file type find doesn't matach
    acceptedTypes.map((type) => {
      if (file.type === type) {
        isValid = true;
      }
    });
    if (isValid) {
      return true;
    }
    event.target.value = null;
    return false;
  }

  isValidSize(event, size) {
    //getting file object
    const file = event.target.files[0];

    if (file && file.size <= size) return true;

    event.target.value = null;
    return false;
  }

  isAdminRole() {
    return (
        auth.getCurrentUserRole() === "ROOT" ||
        auth.getCurrentUserRole() === "ADMIN" ||
        auth.getCurrentUserRole() === "MANAGER" ||
        auth.getCurrentUserRole() === "AUDITOR"
    );
  }
}

export default ShippingHistory;
